

document.addEventListener('DOMContentLoaded', () => {
  function shortdescheight(){
    const descEl = document.querySelector('.collection-bottom-desc');
    const btnEl = document.querySelector('.collection-bottom-desc-btn');
    if (!descEl || !btnEl) return;
    const childEls = [...descEl.children];
    const maxHeight = descEl.getAttribute("data-height");
    let totalHeight = 0;
    function getFullHeight(el) {
      const styles = window.getComputedStyle(el);
      const margin = parseInt(styles.marginTop) + parseInt(styles.marginBottom);
      const padding = parseInt(styles.paddingTop) + parseInt(styles.paddingBottom);
      return margin + padding + el.offsetHeight;
    }
    childEls.forEach(el => {
      totalHeight += getFullHeight(el);
      if(totalHeight > maxHeight) {
        el.classList.add('hidden');
      }
    });
    descEl.classList.add('loaded');
   
    if(document.querySelector('.collection-bottom-desc .hidden')) {
      btnEl.style.display = 'block';
    } else {
      btnEl.style.display = 'none';
    }
    function showAll() {
      childEls.forEach(el => {
        el.classList.remove('hidden');
      });
      btnEl.style.display = 'none';
    }
    btnEl.addEventListener('click', showAll);
  }
  shortdescheight();
 
  $(".blog-tags li").click(function(){
   let  newUrl =  window.location.origin + $(this).attr("data-href");
   requestContent(newUrl);

  });

  function requestContent(newUrl) {
    history.pushState('', '', newUrl);

    fetch(newUrl, {
      credentials: 'same-origin',
      method: 'GET'
    })
      .then(function (response) {
        response.text().then(function (content) {
          console.log('content', content);
          var tempElement = document.createElement('div');
          tempElement.innerHTML = content;
 
          document.querySelector('#community').innerHTML = tempElement.querySelector('#community').innerHTML;

        }).then(function () {
          shortdescheight();
            $(".blog-tags li").click(function(){
                let  newUrl =  window.location.origin + $(this).attr("data-href");
                requestContent(newUrl);
               });
             

        })
      })
      .finally(() => {

      });
  }





});